import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { Subscription } from "rxjs";
import { DashboardMenuTabSelectorService } from "../services/dashboardMenuTabSelector.service";

@Component({
    selector: 'kpi-tab-content',
    template: '<div [style.display]="isVisible?\'block\':\'none\'"><ng-content></ng-content></div>',
    standalone: false
})
export class KpiTabContentComponent implements OnInit, OnDestroy {
    private onSelectedTabChangedSubscription: Subscription;

    @Input() public tabIndex: number;
    public selectedTab: number;
    private mIsVisible: boolean = false;
    public get isVisible(): boolean { return this.mIsVisible; }

    constructor(private tabSelectorService: DashboardMenuTabSelectorService) {
        this.onSelectedTabChangedSubscription = this.tabSelectorService.selectedTabChanged.subscribe((index) => {
            this.mIsVisible = this.tabIndex == index;
        });
    }

    public ngOnInit(): void {
        this.mIsVisible = this.tabIndex == this.tabSelectorService.selectedTab;
    }

    public ngOnDestroy(): void {
        if (this.onSelectedTabChangedSubscription) this.onSelectedTabChangedSubscription.unsubscribe();
    }
}